// Header Slider
ready(function() {

    if (!findAll('.contentblock-header-slider').length)
        return;

    const splide = new Splide( '.contentblock-header-slider .splide', {
        type: 'fade',
        arrows: false,
        pagination: true,
        autoplay: true,
        interval: 4000,
        speed: 2000,
        rewind: true
    } ).mount();

    splide.on("moved", function(newIndex, prevIndex) {
        // Pause all videos first
        const allVideos = document.querySelectorAll('.contentblock-header-slider video');
        allVideos.forEach(video => {
            video.pause();
        });

        // Play videos in the current slide
        const currentSlide = document.querySelector(`.contentblock-header-slider .splide__slide:nth-child(${newIndex + 1})`);
        if (currentSlide) {
            const videos = currentSlide.querySelectorAll('video');
            videos.forEach(video => {
                // Play the appropriate video based on screen width
                const isMobile = window.innerWidth < 1000;
                if ((isMobile && video.classList.contains('video-mobile')) ||
                    (!isMobile && video.classList.contains('video-desktop'))) {
                    video.play().catch(e => console.log('Video play failed:', e));
                }
            });
        }
    });

    // Also handle initial slide on ready
    splide.on("ready", function() {
        const currentSlide = document.querySelector('.contentblock-header-slider .splide__slide.is-active');
        if (currentSlide) {
            const videos = currentSlide.querySelectorAll('video');
            videos.forEach(video => {
                const isMobile = window.innerWidth < 1000;
                if ((isMobile && video.classList.contains('video-mobile')) ||
                    (!isMobile && video.classList.contains('video-desktop'))) {
                    video.play().catch(e => console.log('Video play failed:', e));
                }
            });
        }
    });


});


// 3D Product Slider
ready(function() {
    new ProductSlider('.product-slider');
});


// Manually init Wave Text
ready(function() {
    const wavetextElements = findAll('.wavetext .inner');
    wavetextElements.forEach(element => {
        new WaveText(element, {
            amplitude: -12,
            waveLength: 200,
            slideDirection: 'right',
            slideDuration: 3000,
            trigger: 'scroll',
            threshold: 0.2
        });
    });
});


// Download Boxes
ready(function() {
    const downloadBoxesArray = findAll('.download-boxes');
    if (!downloadBoxesArray.length) return;

    downloadBoxesArray.forEach((downloadBoxes) => {

        const boxes = downloadBoxes.findAll('.download-box');
        boxes.forEach((box) => {
            const allFilesToggle = box.find(".all-files-toggle");
            allFilesToggle.on("click", function(e) {
                e.preventDefault();

                const bottom = box.find(".files-wrap");

                if (box.classList.contains("open")) {
                    bottom.slideUp();
                    box.classList.remove("open");
                } else {
                    bottom.slideDown();
                    box.classList.add("open");
                }


            });
        });

    });
});


// Product Ingredients Tabs
ready(function() {
    const tabs = findAll('.ingredients-item-tabs .tab-link');

    if (!tabs) return;

    const panels = findAll('.ingredients-item');

    tabs.forEach((tab) => {

        console.log(tab);

        tab.on("click", function (event) {


            tabs.forEach(function(aTab) {
                aTab.setAttribute('aria-selected', 'false');
            });

            panels.forEach(function(aPanel) {
                aPanel.setAttribute('hidden', 'true');
            });

            const targetPanelID = this.getAttribute('aria-controls');
            const targetPanel = find("#" + targetPanelID);

            this.setAttribute('aria-selected', 'true');
            targetPanel.removeAttribute('hidden');

        });

    });
})



